export const USE_GENERAL_AI_KNOWLEDGE = 'use-general-ai-knowledge';
export const USE_ROVO_ORGANISATION_KNOWLEDGE = 'use-rovo-organisation-knowledge';
export const BROWSE_AGENTS = 'agent:browse-more-agents';
